import React from "react";
import { Link } from "react-router-dom";
import { MailCheck, MailX } from "lucide-react";

export const LEAD_LABELS = {
  kontakt: "Kontakt", ankauf: "Ankauf", findet: "Wunschfahrzeug", probefahrt: "Probefahrt",
  fahrzeuganfrage: "Fahrzeuganfrage", besichtigung: "Besichtigung",
};

const HIDDEN = new Set(["vehicle_id", "vehicle_url", "fotos"]);

const EmailStatus = ({ lead }) => {
  if (!lead.email_status) return null;
  const ok = lead.email_status === "sent";
  return (
    <span data-testid={`admin-lead-email-status-${lead.id}`} title={lead.email_detail || ""}
      className={`inline-flex items-center gap-1 text-[10px] font-semibold ${ok ? "text-emerald-700" : "text-amber-700"}`}>
      {ok ? <MailCheck size={12} /> : <MailX size={12} />} {ok ? "E-Mail zugestellt" : "E-Mail nicht gesendet"}
    </span>
  );
};

const Lead = ({ l }) => {
  const photos = Array.isArray(l.data?.fotos) ? l.data.fotos.filter((u) => String(u).startsWith("http")) : [];
  const entries = Object.entries(l.data || {}).filter(([k, v]) => !HIDDEN.has(k) && v !== null && v !== "" && !(Array.isArray(v) && !v.length));
  return (
    <div data-testid={`admin-lead-${l.id}`} className="rounded-xl border border-line bg-surface p-6">
      <div className="flex items-center gap-3 flex-wrap">
        <span className="text-[10px] font-semibold px-3 py-1 rounded-full bg-brand text-brand-ink">{LEAD_LABELS[l.type] || l.type}</span>
        <p className="font-semibold text-sm text-ink">{l.name}</p>
        <EmailStatus lead={l} />
        <p className="text-xs text-faint ml-auto">{new Date(l.created_at).toLocaleString("de-AT")}</p>
      </div>
      <p className="text-sm text-dim mt-3">
        {l.email && <a href={`mailto:${l.email}`} className="hover:text-ink">{l.email}</a>}
        {l.email && l.phone && " · "}
        {l.phone && <a href={`tel:${l.phone}`} className="hover:text-ink">{l.phone}</a>}
      </p>
      {l.message && <p className="text-sm text-ink/90 mt-2 whitespace-pre-line">{l.message}</p>}
      {entries.length > 0 && (
        <div className="mt-4 rounded-lg bg-elevated/60 border border-line p-4 grid sm:grid-cols-2 gap-x-6 gap-y-1.5">
          {entries.map(([k, v]) => (
            <p key={k} className="text-xs">
              <span className="text-faint capitalize">{k.replaceAll("_", " ")}: </span>
              <span className="text-ink font-medium break-words">{Array.isArray(v) ? v.join(", ") : String(v)}</span>
            </p>
          ))}
        </div>
      )}
      {l.data?.vehicle_id && (
        <Link to={`/fahrzeuge/${l.data.vehicle_id}`} data-testid={`admin-lead-vehicle-link-${l.id}`} className="inline-block text-xs text-brand hover:underline mt-3">Fahrzeug öffnen →</Link>
      )}
      {photos.length > 0 && (
        <div className="mt-3 flex gap-2 flex-wrap" data-testid={`admin-lead-photos-${l.id}`}>
          {photos.map((u, i) => (
            <a key={`${u}-${i}`} href={u} target="_blank" rel="noopener noreferrer">
              <img src={u} alt={`Foto ${i + 1}`} loading="lazy" className="w-24 h-[72px] object-cover rounded-md bg-deep hover:opacity-80 transition-opacity" />
            </a>
          ))}
        </div>
      )}
    </div>
  );
};

export const AdminLeads = ({ leads }) => (
  <div className="space-y-4" data-testid="admin-leads-list">
    {leads.length === 0 && <p className="text-faint text-sm py-10 text-center">Noch keine Anfragen.</p>}
    {leads.map((l) => <Lead key={l.id} l={l} />)}
  </div>
);

export default AdminLeads;
